<template>
    <div>
        <el-form :inline="true">
            <el-form-item label="用户ID">
                <el-input v-model="queryCondition.userId"></el-input>
            </el-form-item>
            <el-form-item label="交易对">
                <el-input v-model="queryCondition.pair"></el-input>
            </el-form-item>
            <el-form-item label="状态">
               <el-switch v-model="queryCondition.status" active-color="#13ce66" inactive-color="#ff4949"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryCondition.pageNo=1,buildList(queryCondition)">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="operateType = 'create',showEdit = true">新增</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="listInfo">
            <el-table-column prop="userId" label="用户Id"/>
            <el-table-column prop="pair" label="交易对"/>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.status" active-color="#13ce66" inactive-color="#ff4949" @change="alterStatus(scope.row.id,$event)"/>
                </template>
            </el-table-column>
            <el-table-column prop="makerRate" label="maker手续费率"/>
            <el-table-column prop="takerRate" label="taker手续费率"/>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-edit" circle size="small" @click="editMarket(scope.row)"/>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="25" :current-page.sync="queryCondition.pageNo" @current-change="changePage"/>

        <el-dialog title="做市商管理信息编辑" :visible.sync="showEdit" @close="closeDialog">
            <el-form label-width="130px" :model="editInfo" ref="form">
                <el-form-item label="用户ID" prop="userId" :rules="[{ required: true, message: '用户ID不能为空'}]">
                    <el-input v-model="editInfo.userId"/>
                </el-form-item>
                <el-form-item label="交易对" prop="pair" :rules="[{ required: true, message: '交易对不能为空'}]">
                   <el-input v-model="editInfo.pair"/>
                </el-form-item>
                <el-form-item label="maker手续费率" prop="makerRate" :rules="[{ required: true, message: 'maker手续费率不能为空'}]">
                    <el-input v-model="editInfo.makerRate"/>
                </el-form-item>
                <el-form-item label="taker手续费率" prop="takerRate" :rules="[{ required: true, message: 'taker手续费率不能为空'}]">
                    <el-input v-model="editInfo.takerRate"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="submitInfo">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import {mapActions, mapState} from 'vuex';
    import api from './api';
    export default {
        name: "index",
        data(){
            return {
                queryCondition:{
                    userId:'',
                    pair:'',
                    status:'',
                    pageNo:1,
                    size:25
                },
                operateType:'',
                showEdit:false,
                editInfo:{}
            }
        },
        computed: {...mapState('marketMaker', ['listInfo', 'total'])},
        created() {
            this.buildList(this.queryCondition);
        },
        methods:{
            ...mapActions('marketMaker', ['buildList']),
            closeDialog(){
                this.$refs['form'].resetFields();
                this.editInfo = {};
                this.showEdit = false;
            },
            submitInfo() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if (this.operateType === 'create') {
                            api.addMarket(this.editInfo).then(() => {
                                this.$refs['form'].resetFields();
                                this.$message.success('新增信息成功');
                                this.queryCondition.pageNo = 1;
                                this.buildList(this.queryCondition);
                                this.closeDialog();
                            })
                        }

                        if (this.operateType === 'update') {
                            api.updateMarket(this.editInfo).then(() => {
                                this.$refs['form'].resetFields();
                                this.$message.success('修改信息成功');
                                this.queryCondition.pageNo = 1;
                                this.buildList(this.queryCondition);
                                this.closeDialog();
                            })
                        }
                    }
                })
            },
            changePage() {
                this.buildList(this.queryCondition)
            },
            editMarket(row) {
                this.operateType = 'update';
                this.editInfo = JSON.parse(JSON.stringify(row));
                this.showEdit = true;
            },
            alterStatus(id, status) {
                api.updateStatus({id: id, status: status}).then(() => {
                    this.$message.success('状态修改成功');
                    this.queryCondition.pageNo = 1;
                    this.buildList(this.queryCondition);
                })
            },
        }
    }
</script>

<style scoped>

</style>
